export default __webpack_public_path__ + "static/media/gournay.0cdaa8cb.jpg";